import(/* webpackMode: "eager" */ "/root/services/fash-creative/src/app/about/page.tsx")